import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.large,
    minWidth: "260px",
    padding: `0 ${theme.spacing.large} ${theme.spacing.large}`,
    position: "relative",
}));

export const ContentContainer = styled.div({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "68px",
});

export const GiftingImageContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "-80px",
    left: "-14px",
});

export const IconWrapper = styled(Image)<{ leftIcon?: boolean; rightIcon?: boolean }>(
    ({ theme, leftIcon, rightIcon }) => {
        return {
            ...(leftIcon && {
                marginRight: theme.spacing.xxxSmall,
            }),
            ...(rightIcon && {
                marginLeft: theme.spacing.xxxSmall,
            }),
        };
    },
);

export const HeaderTitleWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing.xSmall,
    zIndex: 1,
}));

export const DescriptionText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.large,
}));

export const StyledCloseIcon = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
    cursor: "pointer",
    zIndex: 1,
}));
